"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var BASE = 'wisetack';
var COLOURS = {
  info: 'blue',
  warn: 'pink',
  error: 'red'
};

var Log = /*#__PURE__*/function () {
  function Log() {
    _classCallCheck(this, Log);
  }

  _createClass(Log, [{
    key: "generateMessage",
    value: function generateMessage(level, message, source) {
      // Set the prefix which will cause debug to enable the message
      var namespace = "".concat(BASE, ":").concat(level);
      var createDebug = (0, _debug["default"])(namespace); // Set the colour of the message based on the level

      createDebug.color = COLOURS[level];

      if (source) {
        createDebug(source, message);
      } else {
        createDebug(message);
      }
    }
  }, {
    key: "info",
    value: function info(message, source) {
      return this.generateMessage('info', message, source);
    }
  }, {
    key: "warn",
    value: function warn(message, source) {
      return this.generateMessage('warn', message, source);
    }
  }, {
    key: "error",
    value: function error(message, source) {
      return this.generateMessage('error', message, source);
    }
  }]);

  return Log;
}();

var _default = new Log();

exports["default"] = _default;